<template>
<div>
    <div class="mb-3">
        <img src="../../../assets/images/book/book-title-logo.png" alt="" class="book-title-logo">
        <div class="book-titles">
            <span class="book-title">{{BookParentTitle}}</span> <span class="book-title-2">{{BookSubTitle}}</span>
            <span class="book-sub-title">Words</span>
        </div>
        <div style="clear: both;"></div>
    </div>
    <SubjectBookImage v-if="sectionImageUrl" :url="sectionImageUrl" banner alt="Kelimeler bölümü görseli" />
    <div class="book-contents">
        <div class="book-bg">
            <img src="../../../assets/images/book/book-bg-logo.png" class="lengedu-logo">
        </div>
        <div class="book-content">
            <div v-if="words!=null && words.length>0">
                <ul class="list-group">
                    <li class="list-group-item" v-for="(w,i) in words.filter(x=>x!=null)" :key="w">
                        <div class="float-start">
                            <span class="text-capitalize fs-5">{{i+1}}. {{w.word}}</span> <a v-if="w.word!=null" href=javascript:; @click="playAudio(w.word)"><i class="bi bi-volume-up-fill"></i></a> 
                        </div>
                        <div class="float-end text-capitalize">
                            <small>{{meaningParse(w.meaning)}}</small>
                        </div>
                        <div class="clearfix"></div>
                        <!-- <div class="fst-italic" v-html="exampleParse(w.example)"></div> -->
                        <!-- <a href="javascript:;" class="text-danger" title="Favori Kelime Listesine Ekle"><i class="bi bi-heart float-end"></i></a> -->
                    </li>
                </ul>
                <audio style="display: none;" controls ref="WordPlay" src=""></audio>
            </div>
            <div v-else class="text-center">
                Konuya ait kelime bulunamdı.
            </div>
        </div>
    </div>
</div> 
</template>
<script>
import '../../../assets/styles/book-design.css';
import SubjectBookImage from './SubjectBookImage.vue';
  export default {
    name: "TabLearnWord",
    components: { SubjectBookImage },
    props: {
      sectionImageUrl: { type: String, default: '' },
      words:{
        type:Array
      },
      bookTitle:{
        type: Object
      }
    },
    data() {
      return {
      }
    },
    computed: {
       BookParentTitle(){
        if(this.bookTitle){
            return this.bookTitle.bookParentTitle;
        }
        return '';
       },
       BookSubTitle(){
        if(this.bookTitle){
            return this.bookTitle.bookSubTitle;
        }
        return '';
       }
    },
    methods: {
       playAudio(value){
            let url = process.env.VUE_APP_ROOT_API+"Source/dictionary/audio?word="+value;
            this.$refs.WordPlay.src=url;
            this.$refs.WordPlay.play();
       },
       meaningParse(value){
            let result ='';
            if(value){
                result = value.replace(/\|/gi,', ');
            }
            return result;
       },
       exampleParse(value){
            let result ='';
            if(value){
                result = '<small>'+value.replace(/\|/gi,'<br />')+'</small>';
            }
            return result;
       }
       
    },
    mounted: function() {
        
    }
  };
  </script>
    
  <style></style>
